<div class="customer-contact-select-modal">
  <div *ngIf="(availableRefs$ | async)?.length >0; else noRefs">

    <h2>Au nom de quelle entité voulez-vous vous connecter?</h2>

    <div class="customer-contact-list">
      <div *ngFor="let ref of availableRefs$ | async"
           class="item"
           (click)="onCustomerContactSelect(ref)"
      >
        <div class="logo">
          <i class="fa fa-building-o"></i>
        </div>
        <div class="content">
          <cf-customer-contact-item [ref]="ref"
          ></cf-customer-contact-item>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noRefs>
    <h2>Vous ne semblez pas encore être client chez nous</h2>
    <div class="intro-text">
      <p>
        Contactez-nous sans tarder: <a href="mailto:info@lifeislife.be">info@lifeislife.be</a>
      </p>
      <p>
        Vous pourrez consulter en un coup d'oeil vos polices d'assurances et pension.
      </p>
    </div>
    <div class="actions">
      <a (click)="onLogoutClick()">
        Retour
      </a>
    </div>
  </ng-template>

</div>
